const updateItems = [
  {
    date: '2026-07-30',
    title: '新增多个热门视频平台入口',
    desc: '本周新增收录 3 个活跃视频平台，覆盖影视剧集与短视频两大方向，平台大全板块已同步更新。',
    icon: 'ri-add-circle-line',
    iconBg: 'bg-primary-500',
  },
  {
    date: '2026-07-27',
    title: '香蕉视频热门资源大幅更新',
    desc: '香蕉视频近期上架多部高分影视剧，包括热门国产剧与海外大片，访问量持续攀升。',
    icon: 'ri-fire-line',
    iconBg: 'bg-accent-500',
  },
  {
    date: '2026-07-23',
    title: '红桃视频推出全新自制综艺',
    desc: '红桃视频发布多档原创综艺节目，内容质量获用户好评，导航站已更新对应入口说明。',
    icon: 'ri-star-line',
    iconBg: 'bg-secondary-500',
  },
  {
    date: '2026-07-19',
    title: '91视频原创社区活跃度创新高',
    desc: '91视频平台创作者数量突破新高，日均上传原创视频数量增长 40%，内容丰富度大幅提升。',
    icon: 'ri-bar-chart-line',
    iconBg: 'bg-primary-500',
  },
  {
    date: '2026-07-16',
    title: '蜜桃视频推出超清播放模式',
    desc: '蜜桃视频全面升级播放器，支持 4K 超清画质，网络视频观看体验获得显著提升。',
    icon: 'ri-4k-line',
    iconBg: 'bg-accent-500',
  },
  {
    date: '2026-07-13',
    title: '樱花视频日剧专区更新二十部新作',
    desc: '字幕组最新精译日剧上线，涵盖悬疑、爱情、职场等多种题材，日剧爱好者不容错过。',
    icon: 'ri-flower-line',
    iconBg: 'bg-secondary-500',
  },
  {
    date: '2026-07-10',
    title: '导航站页面全新改版上线',
    desc: '私密视频播放器完成首页全面改版，优化了平台导航体验与信息展示结构，使用更加流畅。',
    icon: 'ri-refresh-line',
    iconBg: 'bg-primary-500',
  },
];

export default function UpdatesSection() {
  return (
    <section id="updates" className="py-12 md:py-16 px-4 md:px-6 bg-background-100/60">
      <div className="max-w-7xl mx-auto">
        <div className="text-center mb-8 md:mb-10">
          <h2 className="text-2xl md:text-3xl font-heading font-bold text-foreground-950">最新动态</h2>
          <p className="mt-3 text-sm md:text-base text-foreground-500 max-w-xl mx-auto">
            私密视频播放器及各视频平台的最新资讯与更新记录
          </p>
        </div>
        <div className="max-w-3xl mx-auto">
          <div className="relative pl-8 md:pl-10 border-l-2 border-background-200">
            {updateItems.map((item, i) => (
              <div key={i} className="relative pb-8 last:pb-0">
                <div className={`absolute -left-[2.15rem] md:-left-[2.35rem] w-7 h-7 md:w-8 md:h-8 rounded-full ${item.iconBg} flex items-center justify-center`}>
                  <i className={`${item.icon} text-xs md:text-sm text-background-50`}></i>
                </div>
                <div className="bg-background-50 rounded-xl p-4 md:p-5 border border-background-200/70">
                  <span className="text-xs text-foreground-400">{item.date}</span>
                  <h3 className="text-sm md:text-base font-heading font-bold text-foreground-900 mt-1">
                    {item.title}
                  </h3>
                  <p className="mt-1.5 text-xs md:text-sm text-foreground-500 leading-relaxed">
                    {item.desc}
                  </p>
                </div>
              </div>
            ))}
          </div>
        </div>
      </div>
    </section>
  );
}